
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function ServicesSection() {
  const navigate = useNavigate();

  const services = [
    {
      id: 'tarot',
      title: '塔羅占卜',
      description: '透過神秘的塔羅牌，為您解讀愛情、事業、財運等人生重要問題',
      icon: 'ri-magic-line',
      image: 'https://public.readdy.ai/ai/img_res/0708e005542561e2eea785de09639eb3.jpg',
      path: '/tarot'
    },
    {
      id: 'bazi',
      title: '八字算命',
      description: '根據您的出生年月日時，精準分析命格特點和人生運勢',
      icon: 'ri-calendar-line',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20fortune%20telling%20with%20ancient%20books%2C%20calligraphy%2C%20and%20feng%20shui%20elements%2C%20warm%20golden%20lighting%2C%20cultural%20atmosphere%2C%20professional%20photography%2C%20high%20quality&width=400&height=300&seq=bazi1&orientation=landscape',
      path: '/bazi'
    },
    {
      id: 'ziwei',
      title: '紫微斗數',
      description: '中華傳統命理學精髓，詳細解析您的命宮星曜和人生格局',
      icon: 'ri-star-line',
      image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20astrology%20chart%20with%20purple%20stars%20and%20traditional%20symbols%2C%20mystical%20purple%20lighting%2C%20elegant%20cultural%20elements%2C%20professional%20photography%2C%20high%20quality&width=400&height=300&seq=ziwei1&orientation=landscape',
      path: '/ziwei'
    },
    {
      id: 'horoscope',
      title: '星座運勢',
      description: '基於西方占星學，為您提供每日、每週、每月的星座運勢指導',
      icon: 'ri-moon-line',
      image: 'https://readdy.ai/api/search-image?query=Zodiac%20constellation%20map%20with%20stars%20and%20celestial%20elements%2C%20cosmic%20blue%20and%20purple%20colors%2C%20mystical%20space%20atmosphere%2C%20professional%20photography%2C%20high%20quality&width=400&height=300&seq=horoscope1&orientation=landscape',
      path: '/astrology'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            專業命理服務
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            我們提供多種傳統與現代相結合的命理諮詢服務，幫助您了解自己，把握人生方向
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <Card key={service.id} hover className="overflow-hidden">
              <div className="relative">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-purple-600 text-white p-2 rounded-lg">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${service.icon} text-lg`}></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{service.description}</p>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full"
                  onClick={() => navigate(service.path)}
                >
                  立即體驗
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
